import ReactDOM from "react-dom";
import { CSSTransition } from "react-transition-group";

import NavLinks from "../NavLinks/NavLinks";
import classes from "./SideDrawer.module.css";

import decoration from './../../../assets/decorations/decoration_1.svg'


// side drawer which contains menu to navigate between pages
const SideDrawer = (props) => {

  const content = (
    <CSSTransition
      in={props.show}
      timeout={300}
      classNames="slide-in-left"
      mountOnEnter
      unmountOnExit
    >
      <aside className={classes.side_drawer} onClick={props.onClick}>
        <div className={classes.body} style={{fontSize: "3vh"}}>
          <div className={classes.top_img_container}>
            <img
              className={classes.top_decoration}
              src={decoration}
              alt="new"
            />
          </div>
          <NavLinks />
          <div className={classes.bottom_img_container}>
            <img
              className={classes.bottom_decoration}
              src={decoration}
              alt="new"
            />
          </div>
        </div>
      </aside>
    </CSSTransition>
  );

  return ReactDOM.createPortal(content, document.getElementById("drawer-hook"));
};

export default SideDrawer;
